// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__Otgd5","title":"style_title__1PBrH","item":"style_item__3Qm3S","trailing":"style_trailing__17rEE"};